import { createAction } from 'redux-actions';
import { createActionBundle } from 'utilities/request';

export const newReportNextStep = createAction('NEW_REPORT/NEXT_STEP');
export const newReportReset = createAction('NEW_REPORT/RESET');

export const storePdfReport = createAction('CREATE_REPORT/STORE_PDF');

export const setTransmissionType = createAction('NEW_REPORT/SET_TRANSMISSION_TYPE');

export const setUnscheduledVisitReason = createAction('NEW_REPORT/SET_UNSCHEDULED_VISIT_REASON');

export const {
  fetch: reportCreate,
  request: requestReportCreate,
  success: requestReportCreateSuccess,
  failure: requestReportCreateFailure,
} = createActionBundle('REPORT/CREATE');

export const {
  fetch: sendEmailDoctorNotification,
  request: requestSendEmailDoctorNotification,
  success: requestSendEmailDoctorNotificationSuccess,
  failure: requestSendEmailDoctorNotificationFailure,
} = createActionBundle('SEND_EMAIL/DOCTOR_NOTIFICATION');

export const {
  fetch: parsePdf,
  request: requestParsePdf,
  success: requestParsePdfSuccess,
  failure: requestParsePdfFailure,
} = createActionBundle('REPORT/PDF_PARSE');
